/* @flow */
import * as React from 'react';

import InputSelect from 'components/InputSelect';

type Props = {
  input: { onChange: () => any, value: any },
  meta: { error: string, touched: boolean },
};

const FormInputSelect = (props: Props): React$Element<any> => {
  const { input, ...otherProps } = props;
  return <InputSelect {...input} {...otherProps} />;
};

export default FormInputSelect;
